import loadable from '@loadable/component';

import { Grid } from '@simplywallst/ui-core';

import { CountryISO } from '@/constants/countries';

import type { usePortfolioPerformanceTimeseries } from '@/hooks/portfolio/usePortfolioPerformanceTimeseries';

import { useResponsiveWidth } from '@/hooks/useResponsiveWidth';

import type { PerformancePeriod } from '../../types';

const Chart = loadable(() => import('./Chart'), {
  resolveComponent: (c) => c.Chart,
});

const RestrictedChart = loadable(() => import('./RestrictedChart'), {
  resolveComponent: (c) => c.RestrictedChart,
});

interface Props {
  isChartRestricted?: boolean;
  market: CountryISO;
  period: PerformancePeriod;
  timeseries: ReturnType<typeof usePortfolioPerformanceTimeseries>['data'];
  timeseriesStatus: 'error' | 'success' | 'pending';
  endTimestamp: number;
  startTimestamp: number;
}

export const Layout = (props: Props) => {
  const { isChartRestricted } = props;
  const chartHeight = 200;
  const { ref, width: chartWidth } = useResponsiveWidth();
  return (
    <Grid ref={ref} templateRows={`min-content ${chartHeight}px`} gap="16px">
      {isChartRestricted ? (
        <RestrictedChart width={chartWidth} height={chartHeight} {...props} />
      ) : (
        <Chart width={chartWidth} height={chartHeight} {...props} />
      )}
    </Grid>
  );
};
